export const LOAD_QUOTES = 'atlas/Quote/LOAD_QUOTES';
export const LOAD_QUOTES_SUCCESS = 'atlas/Quote/LOAD_QUOTES_SUCCESS';
export const DELETE_QUOTE = 'atlas/Quote/DELETE_QUOTE';
export const REMOVE_DELETED_QUOTE = 'atlas/Quote/REMOVE_DELETED_QUOTE';
